<template>
    <PersonHeader>
        <!-- 书架内容 -->
        <div class="bookshelf-content">
            <!-- 二级导航标签 -->
            <div class="sub-nav-tabs">
                <div 
                    class="sub-tab-item" 
                    :class="{ active: TabCur === item.product_type}"
                    @click="switchSubTab(item.product_type)"
                    :key="index"
                    v-for="(item,index) in navList" 
                >
                    {{ item.title }}
                </div>
                <div class="manage-link" v-if="!manageMode" @click="manageMode=!manageMode">
                    管理书架
                </div>
                <div class="del" v-if="manageMode" @click="delsubmit">删除</div>
                <div class="guli" v-if="manageMode" @click="delBook">完成</div>
            </div>
            
            <!-- 书籍网格 -->
            <div >
                <div v-if="search.product_type == 'themeList'" class="books-grid" :class="search.product_type == 'themeList'?' booksTheme-grid':''" v-infinite-scroll="loadMore" @scroll="handleScroll" ref="listContainer"
                infinite-scroll-distance="0">
                    <div 
                        v-for="(item,index) in books" 
                        :key="index" 
                        class="book-item"
                       
                        
                    >
                        <div class="book-cover">
                            <img :src="item.imgUrl" :alt="item.title"  @click="updatebook(item)"/>
                            <div class="check-mask" v-if="manageMode">
                                <input 
                                    :class="{ 'checked': checkedIds.includes(item.bookShelfID) }"
                                    type="checkbox" 
                                    :checked="checkedIds.includes(item.ID)" 
                                    @change="(e) => handleCheck(item, e.target.checked, e)" 
                            >
                            </div>
                        </div>
                        <div class="book-title"  @click="updatebook(item)">{{ item.groupName }}</div>
                    </div>
                </div>
               <div v-else class="books-grid" :class="search.product_type == 'themeList'?' booksTheme-grid':''" v-infinite-scroll="loadMore" @scroll="handleScroll" ref="listContainer"
               infinite-scroll-distance="0">
                <div 
                    v-for="(item,index) in books" 
                    :key="index" 
                    class="book-item"
                    >
                        <div class="book-cover">
                            <img :src="item.img_url" :alt="item.title" @click="setupBackRouterPath(item)"/>
                            <div class="check-mask" v-if="manageMode">
                                <input 
                                    :class="{ 'checked': checkedIds.includes(item.id) }"
                                    type="checkbox" 
                                    :checked="checkedIds.includes(item.id)" 
                                    @change="(e) => handleCheck(item, e.target.checked)"
                            >
                            </div>
                        </div>
                        <div class="book-title" @click="setupBackRouterPath(item)">{{ item.title }}</div>
                    </div>
                    <div v-if="books.length === 0" class="no-data">
                        暂无数据
                    </div>
               </div>
                <!-- 无更多数据提示 -->
                <div v-if="noMore && books&& books.length > 0" class="no-more">
                    已加载全部数据
                </div>
            </div>
        </div>
    </PersonHeader>
</template>

<script>
import PersonHeader from '../../components/PersonHeader.vue'
import ApiUrl from "../../js/apiUrl.js";
import api from '@/api/index.js';
export default {
    name: 'myBookshelf',
    components: {
        PersonHeader
    },
    data() {
        return {
            TabCur: 1,
            token: localStorage.getItem("user_token")||'',
            navList: [],
            search: {
                page_index: 1,
                page_size: 12,
                product_type: 1,
                order_by: "created_at:desc",
                value: "",
                token: localStorage.getItem("user_token")||'',
            },
            totalPage: 1,
            finished: false,
            noMore: false, // 是否无更多数据
            loading: false,
            books: [],
            manageMode: false, // 是否进入删除模式
            hediImg: false,
            checkedIds: [], // 存储选中的书籍 ID
        }
    },
    created() {
        this.setupDetailData()
        this.productDataGet()
    },
    methods: {
        //tab分类
        setupDetailData() {
            var that = this;
            this.Ajax(ApiUrl.yun_product_type_get,{token:this.token} ,function(data) {
                if (data) {
                    let length = data.length>3 ? 3 : data.length
                    for (let i = 0; i < length; i++) {
                        that.navList.push(data[i]);
                    }
                    const showCrop = localStorage.getItem("showCrop");
                    if (showCrop === "Y") {
                        that.tabList.push({
                            img_url: "",
                            product_type: 6,
                            product_count: 0,
                            title: "主题书单"
                        });
                    }
                }
            });
        },
        loadMore() {
        },
        handleScroll(e, item) {
            const container = this.$refs.listContainer;
            if (!container) return;
            // 容器高度计算（核心修复）
            const { scrollTop, clientHeight, scrollHeight } = container;
            const scrollableHeight = scrollHeight - clientHeight; // 可滚动的总高度
            const threshold = 200; // 降低阈值，距离底部200px即触发
            if (scrollTop + threshold >= scrollableHeight && !this.loading && !this.noMore) {
                if (this.loading || this.noMore) return;
                if (!this.finished) {
                    if(this.search.product_type == 'themeList'){
                        this.search.page_index ++
                        this.getShelfList();
                    }else{
                        this.search.page_index ++
                        this.productDataGet();
                    }
                    
                }
            }
        },
        // 电子书列表
        productDataGet(index) {
            var that = this;
            // 如果正在加载或已无更多数据，则不执行
            if (that.loading || that.noMore) return;
            that.loading = true;
            if (index <= 1) {
                that.search.page_index = 1;
                that.totalPage = 1;
            }
            this.Ajax(ApiUrl.yun_search_list_get, this.search, function(data) {
                that.loading = false;
                if (data && data.list) {
                    that.books = [...that.books, ...data.list]
                    that.product_count = data.total;
                    // 判断是否有更多数据
                    that.noMore = that.books.length >= that.product_count;
                    if (that.books.length >= that.product_count || that.total < that.pageSize) {
                        that.finished= true
                    }
                    that.totalPage = data.count;
                }else{
                    that.noMore = true
                    that.loading = false;
                    that.finished= false
                }
                
            }, function() {
                that.loading = false;
            });
        },
        //主题书单
        //学习报告-下面的列表
        getShelfList() {
            // 如果正在加载或已无更多数据，则不执行
            if (this.loading || this.noMore) return;
            this.loading = true;
            api.fetchShelfList({ pageSize: this.search.page_size,pageIndex: this.search.page_index }).then(res => {
                this.loading = false;
                if(res.status===200){
                    console.log("res.data.",res.data)
                    this.books = [...this.books, ...res.data.data]
                    this.product_count = res.data?.total || 0; // 存储总条数
                    // 判断是否有更多数据
                    this.noMore = this.books.length >= this.product_count;
                    if (this.books.length >= this.product_count || this.product_count < this.search.page_size) {
                        this.finished= true
                    }
                }else{
                    this.loading = false;
                    this.finished= false
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        switchSubTab(tab) {
            console.log("tab",tab)
            this.TabCur = tab
            this.search.product_type= tab
            this.search.page_index = 1;
            this.noMore = false;
            this.finished = false;
            this.books = [];
            if(this.search.product_type == 'themeList') {
                // 书单
                this.getShelfList()
                return false
            }
            // 加载新标签数据
            this.productDataGet();
        },
        //选择
        handleCheck(item, isChecked){
            if(this.search.product_type == 'themeList') {
                const { bookShelfID  } = item;
                if (isChecked) {
                    // 选中：添加 ID 到数组
                    this.checkedIds.push(bookShelfID); 
                } else {
                    // 取消选中：从数组中移除 ID
                    const index = this.checkedIds.indexOf(bookShelfID);
                    if (index > -1) {
                        this.checkedIds.splice(index, 1);
                    }
                }
            }else{
                const { id } = item;
                if (isChecked) {
                    // 选中：添加 ID 到数组
                    this.checkedIds.push(id); 
                } else {
                    // 取消选中：从数组中移除 ID
                    const index = this.checkedIds.indexOf(id);
                    if (index > -1) {
                        this.checkedIds.splice(index, 1);
                    }
                }
            }
            
        },
        // 删除
        delsubmit(){
            if (this.checkedIds.length == 0) {
                this.$message({
                    message: '请选择要删除的内容',
                    type: 'error',
                    offset: 330,
                    duration: 1000
                });
                return;
            }
            this.manageMode = false
            if(this.search.product_type == 'themeList') {
                this.datchDelShelf()
                return false
            }
            var that = this;
            this.Ajax(ApiUrl.yun_product_del, {
                product_type: this.search.product_type,
                product_id: this.checkedIds.join(","),
                token: this.$route.query.token,
            }, function(data) {
                that.$message({
                    message: "删除成功",
                    type: 'success',
                    duration: 1000
                });
                that.checkedIds = [];
                that.search.page_index = 1;
                that.noMore = false;
                that.finished = false;
                that.books = [];
                that.productDataGet();
            });

        },
        //删除主题书单
        datchDelShelf(){
            api.fetchBatchDelShelf({ids: this.checkedIds.join(",")}).then(res => {
                this.loading = false;
                if(res.status===200){
                    if(res && res.status) {
                        this.$message({
                            message: "删除成功",
                            type: 'success',
                            duration: 1000
                        });
                        this.checkedIds = [];
                        this.search.page_index = 1;
                        this.noMore = false;
                        this.finished = false;
                        this.books = [];
                        this.getShelfList()
                    } else {
                        uni.showToast({
                            message: '删除成功',
                            type: 'error',
                            offset: 330,
                            duration: 1000
                        });
                    }
                }
            }).catch(() => {
            });
        },
        //完成
        delBook(){
            this.manageMode = !this.manageMode
        },
        //主题书单入口
        updatebook(item){
            this.$router.push({
                path: '/read/booklistDetails',
                query: {
                    id: item.ID,
                    bookListID: item.groupID,
                }
            })
        },
        //跳转·详情
        setupBackRouterPath(item){
            if(this.search.product_type == '1'){
                this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.id,
                        token:this.token
                    }
                })
            }else if(this.search.product_type == '3'){
                this.$router.push({
                    path: '/Audtl',
                    query: {
                        id: item.id,
                        token:this.token
                    }
                })
            }else if(this.search.product_type == '4'){
                this.$router.push({
                    path: '/couraudio',
                    query: {
                        id: item.id,
                        token:this.token
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.bookshelf-content {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 20px 30px;
    position: relative;
    padding-bottom: 35px;
    .sub-nav-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 50px;
        margin-top: 20px;
        position: relative;

        .sub-tab-item {
            padding: 8px 20px;
            margin-right: 10px;
            border-radius: 20px;
            cursor: pointer;
            font-size: 14px;
            color: #333;
            transition: all 0.3s ease;

            &:hover {
                color: #D82A1E;
            }

            &.active {
                background-color: #D82A1E;
                color: #fff;
            }
        }

        .del{
            width: 82px;
            height: 34px;
            color: #e6544c;
            text-align: center;
            font-weight: 500;
            line-height: 34px;
            margin-left: auto;
            cursor: pointer;
        }
        .guli{
            width: 118px;
            height: 34px;
            background: #e6544c;
            border-radius: 17px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            letter-spacing: 1px;
            text-align: center;
            line-height: 34px;
            cursor: pointer;
            margin-left: 0;

        }
        .manage-link {
            margin-left: auto;
            color: #D82A1E;
            font-size: 14px;
            cursor: pointer;
            padding: 8px 0;

            &:hover {
                text-decoration: underline;
            }
        }
    }
    // 无更多数据样式
    .no-more {
        padding: 15px;
        text-align: center;
        color: #aeaeae;
        font-size: 14px;
        position: absolute;
        bottom:-7px;
        left:50%
    }
    .no-data{
        color: #aeaeae;
        position: absolute;
        top:10%;
        left:50%
    }
    .books-grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 40px;
        padding: 0 20px;
        min-height: 200px;
        max-height: 500px;
         overflow-y: auto;
         position: relative;
         
        .book-item {
            cursor: pointer;
            transition: transform 0.2s ease;

            &:hover {
                transform: translateY(-5px);
            }
            .check-mask {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.3);
                display: flex;
                align-items: center;
                justify-content: center;
                input {
                    width: 16px;
                    height: 16px;
                    opacity: 1;
                    border: 1px solid #fff;
                    border-radius: 50%;
                    right: 6px;
                    bottom: 10px;
                    position: absolute;
                    cursor: pointer;
                }
                .checked{
                    background: url(../../assets/image/duihao1.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .book-cover {
                width: 100%;
                aspect-ratio: 3/4;
                background-color: #f0f0f0;
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 10px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .book-title {
                font-size: 16px;
                color: #333;
                line-height: 1.4;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
    .booksTheme-grid{
        grid-template-columns: repeat(3, 1fr);
        .book-cover{
            width: 100%;
            height: 150px;
        }
    }
}
</style> 